import { RootWidgetTypes } from "@/constants";
import { WidgetProvider } from "@/context/widget-provider";
import useUserInfo from "@/hooks/use-user-info";
import useWidgets from "@/hooks/use-widgets";
import React, { useState } from "react";
import { CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

const SystemWidgets: React.FC = () => {
  const [showSystemAlert, setShowSystemAlert] = useState<boolean>(true);

  const userInfo = useUserInfo();
  const { data } = useWidgets(userInfo);
  const alertWidget = data?.find(
    (widget) => widget.rootWidgetId === RootWidgetTypes.SystemAlert,
  );

  const handlePhoneButtonClick = (phone: string | undefined) => {
    window.open(`tel:${phone}`);
  };

  const handleWebButtonClick = (url: string | undefined) => {
    window.open(url, "_blank");
  };

  return (
    <WidgetProvider>
      {alertWidget && showSystemAlert ? (
        // 4.1.3 Status Messages — AA: the banner appears once widget data resolves, with
        // no focus change, so it needs a live region to be announced at all. role="alert"
        // is correct here rather than role="status": an alert IS announced when inserted
        // into the DOM with content, which is exactly how this mounts.
        <div role="alert" className="mb-6 rounded-md bg-yellow-100 p-4">
          <div className="item-center flex flex-row justify-between">
            <CardTitle as="h2" className="text-md">
              {alertWidget?.widgetDisplayName}
            </CardTitle>
            {/*
              2.1.1 Keyboard — A / 4.1.2 Name, Role, Value — A. The dismiss control was a
              bare Lucide <svg> with an onClick: not focusable, no role, no name — so a
              keyboard-only member could never dismiss the banner, and a screen reader user
              was never told it could be dismissed.
            */}
            <button
              type="button"
              onClick={() => setShowSystemAlert(false)}
              aria-label="Dismiss system alert"
              className="rounded focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
            >
              <X aria-hidden="true" className="size-4" />
            </button>
          </div>
          <p className="my-3">{alertWidget?.details[0]?.widgetContent}</p>
          <div className="flex flex-wrap gap-2 self-center md:flex-nowrap">
            {(alertWidget?.details[0]?.phone?.length ?? 0) > 0 ? (
              <Button
                onClick={() =>
                  handlePhoneButtonClick(alertWidget?.details[0]?.phone)
                }
                className="bg-primary"
              >
                {alertWidget?.details[0]?.displayPhoneNumberButtonName}
              </Button>
            ) : null}
            {(alertWidget?.details[0]?.website?.length ?? 0) > 0 ? (
              <Button
                onClick={() =>
                  handleWebButtonClick(alertWidget?.details[0]?.website)
                }
                className="bg-primary"
              >
                {alertWidget?.details[0]?.displayWebsiteName}
              </Button>
            ) : null}
          </div>
        </div>
      ) : null}
    </WidgetProvider>
  );
};
export default SystemWidgets;
